import React from 'react';
import { detectClient, TBA_CLIENT_FID } from '../constants';

export const TBAAdapter = ({ context, children }) => {
  const clientType = detectClient(context);
  const isTBA = clientType === 'tba';
  
  // TBA-specific status indicator
  const renderTBAStatus = () => {
    if (!isTBA) return null;
    
    return (
      <div className="tba-status">
        <div className="tba-indicator">
          <span className="tba-badge">⚡ TBA</span>
          <span className="tba-note">Running in The Base App (Beta)</span>
        </div>
      </div>
    );
  };

  // Enhanced context info for debugging TBA issues
  const renderClientInfo = () => {
    if (!context?.client) return null;
    
    return (
      <div className="client-debug-info">
        <p><strong>Client:</strong> {clientType}</p>
        {context.client.clientFid && (
          <p><strong>Client FID:</strong> {context.client.clientFid}</p>
        )}
        {context.client.name && (
          <p><strong>Client Name:</strong> {context.client.name}</p>
        )}
        {isTBA && (
          <p className="tba-warning">
            ⚠️ TBA Beta: Some features may be limited
          </p>
        )}
      </div>
    );
  };

  return (
    <div className={`client-adapter ${isTBA ? 'tba-mode' : ''}`}>
      {renderTBAStatus()}
      {children}
      {renderClientInfo()}
    </div>
  );
}; 